import React, { useContext, useState } from "react"
import { useSelector } from "react-redux"
import { getShouldShowOptionalInsuranceInfoPromo } from "../../../derivedSelectors"

const ConnectInsuranceContext = React.createContext({
  showOptionalInsuranceInfoPromo: false,
  hideOptionalInsuranceInfoPromo: () => {}
})

export const useConnectInsurance = () => useContext(ConnectInsuranceContext)

export function ConnectInsuranceContextProvider({ children }) {
  const showOptionalInsuranceInfoPromo = useSelector(getShouldShowOptionalInsuranceInfoPromo)
  const [forceHideOptionalInsuranceInfoPromo, setForceHideOptionalInsuranceInfoPromo] = useState(false)
  function hideOptionalInsuranceInfoPromo() {
    setForceHideOptionalInsuranceInfoPromo(true)
  }
  return (
    <ConnectInsuranceContext.Provider
      value={{
        showOptionalInsuranceInfoPromo: !forceHideOptionalInsuranceInfoPromo && showOptionalInsuranceInfoPromo,
        hideOptionalInsuranceInfoPromo
      }}
    >
      {children}
    </ConnectInsuranceContext.Provider>
  )
}
